<script>
    export let currentTime = 0
    export let duration    = 0

    let element = null

    const format = seconds => {
      if (isNaN(seconds)) return '...'
      const minutes = Math.floor(seconds / 60)
      seconds = Math.floor(seconds % 60)
      if (seconds < 10) seconds = '0' + seconds
      return `${minutes}:${seconds}`
    }

    const handleClick = event => {
      const bound   = element.getBoundingClientRect()
      const width   = bound.width
      const clicked = event.clientX - bound.x

      currentTime = (clicked / width) * duration
    }
</script>

<style lang="scss">
  div {
    display: flex;
    align-items: center;
    margin-top: $GU;

    progress {
      position: relative;
      width: 100%;
      height: 5px;
      color: $pink;
      background-color: $white;
      border: none;
      cursor: pointer;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;

      &::-webkit-progress-bar {
        background-color: $white;
      }

      &::-webkit-progress-value {
        background-color: $pink;
      }

      &::-moz-progress-bar {
        background-color: $pink;
      }
    }

    pre {
      margin-left: 1em;
      font-size: 0.8rem;
    }
  }
</style>

<div>
    <progress bind:this={element} max={duration} value={currentTime} on:click={handleClick} />
    <pre>{format(currentTime)} / {format(duration)}</pre>
</div>
